import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@features/auth/core/domain/login/auth-version-2.service';

@Component({
  standalone: true,
  selector: 'app-auth-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
})
export class LogoutComponent implements OnInit {
  authService = inject(AuthService);
  router = inject(Router);
  showLoading: boolean = false;
  constructor() {}

  ngOnInit() {
    this.showLoading = true;
    this.authService.logout().subscribe({
      next: (value) => {
        console.log(value);
        this.router.navigate(['login']);
        this.showLoading = false;
      },
      error: (err) => {
        this.router.navigate(['login']);
        this.showLoading = false;
        console.error(`Error when logout: ${err.message}`);
      },
    });
  }
}
